import React from 'react';
import { CalendarRangeIcon, UserRoundIcon } from 'lucide-react';
import type { PayPeriod } from '../types/payment';
import { formatDateRange } from '../utils/paymentConfig';
import { CommissionModelBadge } from './CommissionModelBadge';
export function ContextCard({
  payPeriod
}: {
  payPeriod: PayPeriod;
}) {
  return <section aria-label="Pay period context" className="rounded-lg border border-ink-200 bg-white px-5 py-4 shadow-card" data-id="element-32" data-mp="1ts1h1gfhqumb">
      <div className="flex items-start justify-between gap-4" data-id="element-33" data-mp="x5ey4zmzv5h7">
        <div className="min-w-0" data-id="element-34" data-mp="122yd61rinma7">
          <p className="text-xs font-medium uppercase tracking-wide text-ink-400" data-id="element-35" data-mp="123zzx3hw9x7r">
            Employee Pay Period
          </p>
          <p className="mt-1 truncate text-base font-semibold text-ink-900" data-id="element-36" data-mp="1b3czn4g7v7fa">
            {payPeriod.name}
          </p>
        </div>
        <CommissionModelBadge model={payPeriod.commissionModel} data-id="element-37" data-mp="2hi46dos0tmh8" />
      </div>

      <dl className="mt-4 grid gap-4 border-t border-ink-100 pt-4 sm:grid-cols-2" data-id="element-38" data-mp="2mh7btabwxupq">
        <div className="flex items-start gap-2.5" data-id="element-39" data-mp="1pdrm3t2farck">
          <UserRoundIcon className="mt-0.5 h-4 w-4 shrink-0 text-ink-400" aria-hidden="true" data-id="element-40" data-mp="1pcghjr15lfke" />
          <div className="min-w-0" data-id="element-41" data-mp="1ff213rf8cqs3">
            <dt className="text-xs font-medium text-ink-500" data-id="element-42" data-mp="1fe0rlrdv4cch">Team member</dt>
            <dd className="truncate text-sm font-medium text-ink-900" data-id="element-43" data-mp="1agh19t3w4946">
              {payPeriod.employeeName}
            </dd>
            <dd className="truncate text-xs text-ink-500" data-id="element-44" data-mp="16ff91w8e4xbp">{payPeriod.employeeRole}</dd>
          </div>
        </div>
        <div className="flex items-start gap-2.5" data-id="element-45" data-mp="11m2pw1mhdiqc">
          <CalendarRangeIcon className="mt-0.5 h-4 w-4 shrink-0 text-ink-400" aria-hidden="true" data-id="element-46" data-mp="woavn0yd5kiz" />
          <div className="min-w-0" data-id="element-47" data-mp="rqslj78m0z9e">
            <dt className="text-xs font-medium text-ink-500" data-id="element-48" data-mp="rnd808ul3ya3">Pay period</dt>
            <dd className="numeric text-sm font-medium text-ink-900" data-id="element-49" data-mp="mpv7n6umurdp">
              {formatDateRange(payPeriod.startDate, payPeriod.endDate)}
            </dd>
            <dd className="text-xs text-ink-500" data-id="element-50" data-mp="8366z1ona85q">Semi-monthly · Open</dd>
          </div>
        </div>
      </dl>
    </section>;
}